export const movieStatuses = {
  TESTING: -1,
  HIDDEN: 0,
  FOR_ADVERTISE: 1,
  ACTIVE: 2,
  SOLD_OUT: 3
};
